module.exports = __webpack_public_path__ + "static/media/28.69613aaf.png";